import { postData, getData, putData, deleteData, postFileUpload } from './Webservice';

const getToken = () => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    return token ? `Bearer ${token}` : '';
};

// Combo Offer APIs
export const createCombo = async (data) => {
    if (data instanceof FormData) {
        return await postFileUpload(`combo-offer/create`, data, getToken(), false);
    }
    return await postData(`combo-offer/create`, data, getToken(), false);
};

export const getAllCombos = async (params) => {
    return await getData(`combo-offer/all`, params, getToken(), false);
};

export const getComboById = async (id) => {
    return await getData(`combo-offer/${id}`, {}, getToken(), false);
};

export const updateCombo = async (id, data) => {
    const isFormData = data instanceof FormData;
    const action = isFormData ? (data.get('action') || 'Update') : (data.action || 'Update');
    const entity = isFormData ? (data.get('entity') || 'Combo Offer') : (data.entity || 'Combo Offer');
    const createdBy = isFormData ? (data.get('createdBy') || sessionStorage.getItem('userId') || localStorage.getItem('userId') || '') : (data.createdBy || sessionStorage.getItem('userId') || localStorage.getItem('userId') || '');

    // Append to query string as a fallback for backend validation
    const query = `?action=${encodeURIComponent(action)}&entity=${encodeURIComponent(entity)}&createdBy=${encodeURIComponent(createdBy)}`;
    return await putData(`combo-offer/update/${id}${query}`, data, getToken(), false);
};

export const deleteCombo = async (id) => {
    return await deleteData(`combo-offer/delete/${id}`, getToken(), false);
};

// BOGO Offer APIs
export const createBogo = async (data) => {
    return await postData(`bogo-offer/create`, data, getToken(), false);
};

export const getAllBogos = async (params) => {
    return await getData(`bogo-offer/all`, params, getToken(), false);
};

export const getBogoById = async (id) => {
    return await getData(`bogo-offer/${id}`, {}, getToken(), false);
};

export const updateBogo = async (id, data) => {
    const action = data.action || 'Update';
    const entity = data.entity || 'BOGO Offer';
    const createdBy = data.createdBy || sessionStorage.getItem('userId') || localStorage.getItem('userId') || '';

    const query = `?action=${encodeURIComponent(action)}&entity=${encodeURIComponent(entity)}&createdBy=${encodeURIComponent(createdBy)}`;
    return await putData(`bogo-offer/update/${id}${query}`, data, getToken(), false);
};

export const deleteBogo = async (id) => {
    return await deleteData(`bogo-offer/delete/${id}`, getToken(), false);
};
